// byt.js — DENNIK_TUK_V1: názov bytu zo Výmer na zobrazenie (nález skúšky iOS, ksbx-appky 2929: „byt BYT II.“).
// Výmery majú byt raz ako kód („100“, „A“, „B2-04-04“ — 302 z 311 názvov), raz ako názov so slovom
// („BYT II.“, „SPOLOČNÉ PRIESTORY“ — 9 z 311). Slovo „byt“ patrí len pred kód. To isté pravidlo má server
// v dennik_katalog.js (bytNazov) pre text do knihy a PDF.
export const bytMaSlovo = (b) => /\p{L}{3,}/u.test(String(b || ''))
export const bytNazov = (b, slovo = 'byt') => {
  const s = String(b || '').trim()
  if (!s) return ''
  return bytMaSlovo(s) ? s : slovo + ' ' + s
}
